import { UI } from '../ui';

export let nav = {

    self : this,
    menuClass : 'nav-top',
    hasSubmenuClass : 'has-submenu',
    submenuClass: 'sub-menu',
    openClass : 'open',

    /**
     *	Binds multi-level navigation UX to menu element
        *
        * @param {string} menuClass
        * @param {string} hasSubmenuClass
        * @param {string} submenuClass
        * @param {string} openClass
        */
    bind : function(menuClass = this.menuClass, hasSubmenuClass = this.submenuClass, submenuClass = this.submenuClass, openClass = this.openClass) {

        // parent object {nav}
        let self = this;

        const menuEl = document.querySelector('.'+menuClass);

        if(menuEl === null) return;

        let navLinks = menuEl.querySelectorAll('a');

        navLinks.forEach( function(item) {

            let li = item.parentNode;

            if( li.classList.contains(hasSubmenuClass) ) {

                item.addEventListener('click', function(event) {

                    // console.log( li );
                    
                    //direct reference to (grand) parent object
                    if( UI.windowWidth <= 960 ) {
                        
                        self.toggleSubmenu(li, openClass);
                        event.preventDefault();
                        //console.log( ' menu link clicked and we are on mobile-width ' );

                    // on desktop-width toggle submenu only for first level (we are checking this via direct parent class)
                    // using closest() method, see: https://developer.mozilla.org/en-US/docs/Web/API/Element/closest for reference (older browsers might need polyfills)
                    // and for alternatives:
                    // http://clubmate.fi/jquerys-closest-function-and-pure-javascript-alternatives/
                    // http://codeblog.cz/vanilla, http://youmightnotneedjquery.com/, https://gist.github.com/joyrexus/7307312						
                    } else if ( UI.windowWidth > 960 && !li.closest('ul').classList.contains(submenuClass) ) {
                        self.toggleSubmenu(li, openClass);
                        event.preventDefault();
                        //console.log( ' menu link clicked and we are on desktop-width ' );
                    }	

                });

            }				

        });

        self.toggleMenu(menuEl);

    },

    toggleMenu : function(menu) {

        const button = document.querySelector('.do-toggle-nav');

        button.addEventListener('click', function(event) {
            menu.classList.toggle('open');
            button.classList.toggle('open');
            event.preventDefault();
        });

    },

    toggleSubmenu : function (li, openClass) {

        //select siblings
        let siblings = Array.prototype.filter.call(li.parentNode.children, function(child){
            return child !== li;
        });			

        //remove open class from siblings
        siblings.forEach( function(sibling) {
            sibling.classList.remove(openClass);
        });

        // toggle open class
        li.classList.toggle(openClass);	

    },

}